// extracted by mini-css-extract-plugin
export default {"search-filters":"search-filters---T1p8b"};